import React from 'react';

const projects = [
  {
    image: '/projects/ONE.png',
    title: 'Project Management App - ( In Progress Personal Project )',
    position: 'WEB APP | Full Stack Developer',
    year: '2026',
    desc: 'Developed a full-stack project management web application that allows users to create and manage projects, add and assign tasks, and collaborate with team members. The app features user management and a Kanban board interface for visual task tracking, providing an intuitive way to organize workflows and monitor project progress',
    link: '#',
  },
  {
    image: '/projects/ETL.png',
    title: 'ETL Pipeline – Automated Data Validation System',
    position: 'WEB APP | Full Stack Developer',
    year: '2025',
    desc: 'Built a Python + Flask + Pandas-based data validation and transformation tool. Automated file ingestion from CSV/XLSX into SQL databases, reducing manual upload time by 60%.',
    link: '#',
  },
  {
    image: '/projects/LILO.png',
    title: 'LILO V2 Dashboard – Company Analytics Dashboard',
    position: 'WEB APP | Full Stack Developer',
    year: '2025',
    desc: 'Created an EJS + Node.js admin dashboard for tracking company employee analytics. Integrated SQLite database with data visualization features for management insights.',
    link: '#',
  },
  {
    image: '/projects/VALSAFE.png',
    title: 'ValSafe – Centralized Incident Reporting App',
    position: 'WEB APP | Project Manager',
    year: '2025',
    desc: 'Developed a React Native mobile app for Valenzuela City to report real-time emergencies (accidents, fires, medical). Integrated Mapbox API for real-time responder tracking and location-based routing. Led a 5-member team using Agile principles; improved response speed simulation by 35%.',
    link: '#',
  },
  {
    image: '/projects/DJM.png',
    title: 'DJMTech – E-Commerce Platform for Computer Parts',
    position: 'WEB APP | Full Stack Developer',
    year: '2025',
    desc: 'Built and maintained a full-stack website using HTML, CSS, JavaScript, PHP, and MySQL. Designed the User Account module (CRUD features, purchase history, profile management).Enhanced UI responsiveness and reduced page load times by 25%.',
    link: '#',
  },
];

export default function Projects() {
  return (
    <section id="projects" className="container projects">
      <h2>Projects</h2>
      <div className="project-grid">
        {projects.map((p) => (
          <article className="project-card" key={p.title}>
            <div className='image-container'>
              <img src={p.image} alt={p.image}/>
            </div>
            <div className="project-flex">
              <div>
                <h4>{p.title}</h4>
                <p>{p.position}</p>
              </div>
              <p>{p.year}</p>
            </div>
            <p>{p.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
